import React, { Component } from 'react';
import classNames from 'classnames';

import groupBy from 'lodash/groupBy';
import ColorPicker from '../ColorPicker';
import withModifierDetails from './WithModifierDetails';

import { getModifierOptionBackground } from '../../../../../utils/Utils';

export class RadioDials extends Component {
  render(activeOption) {
    const {
      modifier: {
        slug,
        options,
      },
    } = this.props;
    const groups = groupBy(options, 'groupName');

    return Object.entries(groups).map(([groupName, groupOptions]) => (
      <div key={groupName} className="pdp-options-group">
        {groupName.length > 0 && !groupName.includes('null') && (
          <div className="pdp-options-group-name">{groupName}</div>
        )}
        <div className={classNames('pdp-options-ul', slug?.toLowerCase())}>
          {groupOptions.map((option) => {
            const {
              value,
              description,
              asset,
              colors,
              borderColor,
            } = option;
            const active = activeOption?.value === value;

            return (
              <ColorPicker
                active={active}
                asset={asset}
                backgroundColor={colors?.length > 0 ? getModifierOptionBackground(colors) : undefined}
                borderColor={borderColor ? borderColor.hex : undefined}
                description={description}
                hasBorder={!!borderColor?.hex}
                onClick={() => this.selectModifierOption(option)}
                key={value}
                value={value}
              />
            );
          })}
        </div>
      </div>
    ));
  }
}

const RadioDialsModifier = withModifierDetails(RadioDials);

export default RadioDialsModifier;
